import * as THREE from 'three';
import WsManagement from '../../api/WsManagement';
import ThreeDScene from '../ThreeDScene';
import { ComponentContext, LoadableUIFactory as LoadableUIFactory } from '../../api/UIService';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { BaseActor } from './behaviors/BaseActor';
import { Vec2 } from '../../models/SyntheticMap';

export enum InteractionEventType {
  Click = 'click',
  Move = 'move',
  Down = 'down',
  Wheel = 'wheel',
  ObjectMove = 'objectMove',
  WholeMapSelect = 'wholeMapSelect',
  LightPropertiesSelect = 'lightPropertiesSelect',
  SitePropertiesSelect = "sitePropertiesSelect",
  EnvionmentPropertiesSelect = "environmentPropertiesSelect",
  RightClick = "RightClick",
  ShowScenarios = "ShowScenarios",
}


export interface InteractionEvent {
  loc: THREE.Vector3;
  object: THREE.Object3D;
  type: InteractionEventType;
  comp?: BaseThreeDFactory;
  part?: THREE.Object3D;
  deltaY?: number;
}

export abstract class BaseThreeDFactory implements LoadableUIFactory {
  public scene!: ThreeDScene;
  public wsManagement!: WsManagement;
  public ctx!: ComponentContext;
  public actors = new Map<THREE.Object3D, BaseActor>();
  public static gltfLoader = new GLTFLoader();
  public supportsSelection(obj: THREE.Object3D): boolean {
    return false;
  }
  public async loadComponent(ctx: ComponentContext): Promise<void> {
    this.ctx = ctx;
    this.scene = ctx.scene;
    this.wsManagement = ctx.wsManagement;
    await this.load();
    await this.onMapLoad();
  }
  abstract load(): Promise<void>;
  public captureMouse() {
    return false;
  }
  public unloadComponent() {
    this.unload();
  }
  protected registerTargets(obj: THREE.Object3D, scannable = false) {
    // this.ctx.scene.mouseClickTargets.unshift(obj);
    const scannableObj = this.getScannableObject(obj);
    if (scannable && scannableObj) {
      // this.ctx.scene.mouseClickTargets.unshift(scannableObj);
      this.scene.scannableObjects.push(scannableObj);
      // } else {
    }
    if (scannableObj) {
      this.scene.mouseClickTargets.push(scannableObj);
    } else {
      this.scene.mouseClickTargets.push(obj);
    }
    (obj as any).comp = this;
  }
  protected unregisterTargets(obj: THREE.Object3D) {
    obj = this.getScannableObject(obj) || obj;
    const idx = this.ctx.scene.mouseClickTargets.indexOf(obj);
    if (idx > -1) {
      this.ctx.scene.mouseClickTargets.splice(idx, 1);
    }
    const idx2 = this.scene.scannableObjects.indexOf(obj);
    if (idx2 > -1) {
      this.scene.scannableObjects.splice(idx2, 1);
    }
  }

  protected getScannableObject(obj: THREE.Object3D): THREE.Object3D | null {
    return null;
  }

  public getFriendlyName(obj: THREE.Object3D): string {
    return this.constructor.name;
  }
  public getActor(obj: THREE.Object3D): BaseActor | null {
    return this.actors.get(obj) || null;
  }
  public createActor(obj: THREE.Object3D): BaseActor | null {
    return null;
  }
  protected unload(): void { };
  public isBrowsable(obj: THREE.Object3D): boolean {
    return true;
  }
  onObjectMove(e: InteractionEvent): void { }
  onMouseOver(e: InteractionEvent): void { }
  onMouseDown(e: InteractionEvent): void { }
  onMouseUp(e: InteractionEvent): void { }
  onMouseWheel(e: InteractionEvent): void { }
  onMapSave(): void { }
  async onMapLoad(): Promise<void> { }
  public renderMap(ctx: CanvasRenderingContext2D, resolution: number, convertToMapCoordinates: (x: number, y: number) => Vec2): void { }
}
